/**
 * Created by r4zi4l on 08.02.2021
 */

const Map2dAdviceBaseLogic = function (options) {
    options = options || {};

    this.region = options.region;
    this.preferCell = options.preferCell;

    if (options.cells) {
        this.cells = cleverapps.toArray(options.cells);
    }

    const targets = cleverapps.toArray(options.targets);
    if (targets && targets.length > 0) {
        this.targets = targets;
    }
};

Map2dAdviceBaseLogic.prototype.findMove = function () {

};

Map2dAdviceBaseLogic.prototype.listAvailableUnits = function () {
    let units;

    if (this.cells) {
        units = this.cells.map((cell) => Map2d.currentMap.getUnit(cell.x, cell.y)).filter((unit) => unit);
    } else if (this.region) {
        units = Map2d.currentMap.listAvailableUnitsInRegion(this.region);
    } else if (this.preferCell) {
        const preferUnit = Map2d.currentMap.getUnit(this.preferCell.x, this.preferCell.y);
        units = preferUnit ? [preferUnit] : Map2d.currentMap.listAvailableUnits();
    } else {
        units = Map2d.currentMap.listAvailableUnits();
    }

    if (this.targets) {
        const groups = {};
        this.targets.forEach((target) => {
            groups[Unit.GetKey(target)] = [];
        });

        units.forEach((unit) => {
            const key = Unit.GetKey(unit);
            if (groups[key]) {
                groups[key].push(unit);
            }
        });

        units = this.targets.reduce((array, target) => array.concat(groups[Unit.GetKey(target)]), []);
    }

    if (this.priority) {
        units = units.sort((a, b) => this.getPriorityIndex(a) - this.getPriorityIndex(b));
    }

    return units;
};

Map2dAdviceBaseLogic.prototype.isApplicable = function (unit) {
    return !this.targets || Unit.IsApplicable(this.targets, unit);
};

Map2dAdviceBaseLogic.prototype.isPriorityUnit = function (unit) {
    return this.getPriorityIndex(unit) < 10000;
};

Map2dAdviceBaseLogic.prototype.getPriorityIndex = function (unit) {
    return this.priority && this.priority[Unit.GetKey(unit)] || 10000;
};
